const DEFAULT_YEAR = 1900

import moment from 'moment-timezone'

export const getDateForDayAndMonthPicker = (
  date: string | null | undefined,
  timezone = moment.tz.guess(),
): Date | null => {
  if (date) {
    return moment.tz(`${DEFAULT_YEAR}-${date}`, timezone).toDate()
  }

  return null
}
